/* Custom Fireside — "Available online" switch (Oct 2026).
   Markup: snippets/cf-online-switch.liquid (rendered by snippets/facets.liquid).

   Turning the switch on/off adds/removes the Availability filter
   (filter.p.m.custom.availability=Available Online) and reloads the product
   grid without a page reload, using the theme's own filter code (facets.js).
   The desktop switch lives in the filter bar; the phone switch sits next to
   the Filter button, outside the filter drawer, so after every grid update
   it copies the desktop switch's state and count. */
(function () {
  var INPUT = 'cf-online-switch__input';

  function isSwitch(el) {
    return el && el.classList && el.classList.contains(INPUT);
  }

  // The desktop switch sits inside the filter form; keep the form's own
  // "input" handler from also firing (it would submit a second time).
  document.addEventListener(
    'input',
    function (event) {
      if (isSwitch(event.target)) event.stopPropagation();
    },
    true
  );

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!isSwitch(input)) return;

    var param = input.getAttribute('data-param');
    var value = input.getAttribute('data-value');
    var on = input.checked;

    document.querySelectorAll('.' + INPUT).forEach(function (other) {
      other.checked = on;
    });

    var params = new URLSearchParams(window.location.search);
    var others = params.getAll(param).filter(function (v) {
      return v !== value;
    });
    params.delete('page');
    params.delete(param);
    others.forEach(function (v) {
      params.append(param, v);
    });
    if (on) params.append(param, value);
    var query = params.toString();

    // facets.js declares FacetFiltersForm as a class, which is a global name
    // but not a window property, so check it with typeof.
    if (typeof FacetFiltersForm !== 'undefined' && document.getElementById('product-grid')) {
      FacetFiltersForm.renderPage(query);
    } else {
      window.location.search = query;
    }
  });

  // Phone switch: mirror the desktop switch after each filter update
  // (any filter, the switch itself, or the browser back/forward buttons).
  function syncPhoneSwitch() {
    var phone = document.querySelector('[data-cf-online-mobile]');
    if (!phone || !document.getElementById('FacetFiltersForm')) return;

    var desktop = document.querySelector('#FacetFiltersForm [data-cf-online]');
    phone.hidden = !desktop;
    if (!desktop) return;

    var desktopInput = desktop.querySelector('.' + INPUT);
    var phoneInput = phone.querySelector('.' + INPUT);
    if (desktopInput && phoneInput) phoneInput.checked = desktopInput.checked;

    var desktopCount = desktop.querySelector('[data-cf-online-count]');
    var phoneCount = phone.querySelector('[data-cf-online-count]');
    if (desktopCount && phoneCount) phoneCount.textContent = desktopCount.textContent;
  }

  function watchGrid() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || !window.MutationObserver) return;
    new MutationObserver(syncPhoneSwitch).observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchGrid);
  } else {
    watchGrid();
  }
})();
